export const generateShortId = (length = 6) => {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; // Excluded O, I, 0, 1 for clarity
    let result = '';
    for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
};

/**
 * Anonymizes a full name by showing the first name and only the first letter of the last name.
 * Example: "Alper Kamu" -> "Alper K****"
 */
export const anonymizeName = (name) => {
    if (!name) return '';
    const parts = name.trim().split(/\s+/);
    if (parts.length === 0) return '';
    if (parts.length === 1) return parts[0];
    
    // Last word is usually the surname
    const firstName = parts.slice(0, -1).join(' ');
    const lastName = parts[parts.length - 1];
    
    if (lastName.length === 0) return firstName;
    
    return `${firstName} ${lastName[0]}****`;
};

/**
 * Anonymizes a phone number by masking the last 4 digits.
 * Example: "+90 555 123 4567" -> "+90 555 123 ****"
 */
export const anonymizePhone = (phone) => {
    if (!phone) return '';
    const cleanPhone = String(phone).trim();
    if (cleanPhone.length < 5) return '****';
    return cleanPhone.slice(0, -4) + '****';
};

/**
 * Anonymizes an email address.
 * Keeps the first character and the last character before @, masks everything else in between.
 * Example: "alper@gmail.com" -> "a***r@gmail.com"
 */
export const anonymizeEmail = (email) => {
    if (!email || !email.includes('@')) return email;
    const [localPart, domain] = email.split('@');
    if (localPart.length <= 2) return email;
    
    const first = localPart[0];
    const last = localPart[localPart.length - 1];
    const masked = '*'.repeat(localPart.length - 2);
    
    return `${first}${masked}${last}@${domain}`;
};
